import React, { useState } from 'react';
import { countLabel, RecordToolbar } from 'components/record-shell/RecordList';
import { Grid } from '@mui/material';

import ConfirmDialog from 'components/confirm-dialog/ConfirmDialog';
import ProcedureDoctorsList from './list/ProcedureDoctorsList';
import ProcedureDoctorForm from './form/ProcedureDoctorForm';
import { Procedure, ProcedureDoctor } from 'types/procedure';

interface ProcedureDoctorsProps {
  procedure: Procedure;
  handleChangeAddDoctor(pkg: ProcedureDoctor): void;
  handleDeleteDoctor(pkg: ProcedureDoctor): void;
}

const ProcedureDoctors: React.FC<ProcedureDoctorsProps> = ({
  procedure,
  handleDeleteDoctor,
  handleChangeAddDoctor,
}) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<ProcedureDoctor | null>(null);
  const [doctorInfo, setDoctorInfo] = useState<ProcedureDoctor>({
    sale_price_max: 0,
    sale_price_min: 0,
    doctor: null,
    id: 0,
    doctor_id: 0,
    procedure_id: 0,
  });

  function handleChangeDoctorInfo<K extends keyof ProcedureDoctor>(index: K, value: ProcedureDoctor[K]) {
    setDoctorInfo(prev => ({ ...prev, [index]: value }));
  }

  function handleAddDoctor(doctorInfo: ProcedureDoctor | null) {
    if (!doctorInfo) return;
    handleChangeAddDoctor(doctorInfo);
    setAddDialogOpen(false);
    setDoctorInfo({
      sale_price_max: 0,
      sale_price_min: 0,
      doctor: null,
      id: 0,
      doctor_id: 0,
      procedure_id: 0,
    });
  }

  function onExited() {
    setAddDialogOpen(false);
    setDoctorInfo({
      sale_price_max: 0,
      sale_price_min: 0,
      doctor: null,
      id: 0,
      doctor_id: 0,
      procedure_id: 0,
    });
    setEditDialogOpen(false);
  }

  function handleEditDoctor(procedure: ProcedureDoctor, index: number) {
    setEditDialogOpen(true);
    setDoctorInfo(procedure);
  }

  return (
    <Grid container size={12} spacing={2}>
      {confirmDialogOpen && (
        <ConfirmDialog
          confirmLabel="Excluir"
          destructive
          handleNoClick={() => setConfirmDialogOpen(null)}
          handleYesClick={() => {
            handleDeleteDoctor(confirmDialogOpen);
            setConfirmDialogOpen(null);
          }}
          title="Tem certeza que deseja excluir este médico?"
        />
      )}
      <Grid size={12}>
        <RecordToolbar
          title={countLabel(
            procedure.doctors.length,
            'médico cadastrado',
            'médicos cadastrados',
            'Nenhum médico cadastrado',
          )}
          addLabel="Adicionar médico"
          onAdd={() => setAddDialogOpen(true)}
        />
      </Grid>

      {procedure.doctors.length > 0 && (
        <ProcedureDoctorsList
          doctors={procedure.doctors}
          handleDeleteDoctor={pkg => setConfirmDialogOpen(pkg)}
          handleEditDoctor={handleEditDoctor}
        />
      )}

      {addDialogOpen && (
        <ProcedureDoctorForm
          type="new"
          handleChangeDoctorInfo={handleChangeDoctorInfo}
          doctorInfo={doctorInfo}
          handleAddDoctor={handleAddDoctor}
          onExited={onExited}
        />
      )}

      {!!doctorInfo.id && editDialogOpen && (
        <ProcedureDoctorForm
          type="edit"
          handleChangeDoctorInfo={handleChangeDoctorInfo}
          doctorInfo={doctorInfo}
          handleAddDoctor={handleAddDoctor}
          onExited={onExited}
        />
      )}
    </Grid>
  );
};

export default ProcedureDoctors;
